import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const UA_MONTHS = ['Січень','Лютий','Березень','Квітень','Травень','Червень','Липень','Серпень','Вересень','Жовтень','Листопад','Грудень'];
const UA_DAYS = ['Пн','Вт','Ср','Чт','Пт','Сб','Нд'];

export default function AdminDashboard() {
  const [tab, setTab] = useState('excursions');
  const [orders, setOrders] = useState([]);
  const [orderSearch, setOrderSearch] = useState('');
  const searchInputRef = useRef(null);

  useEffect(() => {
    if (tab !== 'orders') return;
    const timer = setTimeout(() => {
      fetchOrders(orderSearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [orderSearch, tab]);
  const [basePrice, setBasePrice] = useState('');
  const [childPrice, setChildPrice] = useState('');
  const [discountPrice, setDiscountPrice] = useState('');
  const [freeDiscountPrice, setFreeDiscountPrice] = useState('');
  const [excursionPrice, setExcursionPrice] = useState('');
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [excursions, setExcursions] = useState([]);
  const [reservedDates, setReservedDates] = useState([]);
  const [form, setForm] = useState({ date: '', time: '', adults: '', children: '', discounts: '', responsible_name: '', responsible_phone: '', status: 'не оплачено', notes: '' });
  const [selectedDate, setSelectedDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const navigate = useNavigate();

  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    if (!token) {
      navigate('/admin/login');
      return;
    }
    fetchPrice();
    fetchExcursions();
    fetchReserved();
    fetchOrders();
  }, [token, navigate]);

  const fetchPrice = async () => {
    try {
      const res = await fetch('/api/settings/prices', {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      setBasePrice(data.base_price);
      setChildPrice(data.child_price);
      setDiscountPrice(data.discount_price);
      setFreeDiscountPrice(data.free_discount_price);
      setExcursionPrice(data.excursion_price);
    } catch (err) {
      console.error(err);
    }
  };

  const savePrice = async (e) => {
    e.preventDefault();
    try {
      await fetch('/api/settings/price', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ base_price: parseFloat(basePrice), child_price: parseFloat(childPrice), discount_price: parseFloat(discountPrice), free_discount_price: parseFloat(freeDiscountPrice), excursion_price: parseFloat(excursionPrice) }),
      });
      alert('Збережено');
    } catch (err) {
      alert('Помилка');
    }
  };

  const changeCredentials = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/auth/change-credentials', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ new_username: newUsername, new_password: newPassword }),
      });
      if (res.ok) {
        alert('Збережено');
        setNewUsername('');
        setNewPassword('');
      } else {
        const d = await res.json();
        alert(d.error || 'Помилка');
      }
    } catch (err) {
      alert('Помилка');
    }
  };

  const fetchExcursions = async () => {
    try {
      const res = await fetch('/api/excursions', {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) { navigate('/admin/login'); return; }
      setExcursions(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchOrders = async (q) => {
    try {
      const url = q ? `/api/orders?q=${encodeURIComponent(q)}` : '/api/orders';
      const res = await fetch(url, {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      setOrders(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
      setOrders([]);
    }
  };

  const fetchReserved = async () => {
    try {
      const res = await fetch('/api/excursions/reserved', {
        headers: { 'Authorization': `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.status === 401 || res.status === 403) { navigate('/admin/login'); return; }
      setReservedDates(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error(err);
    }
  };

  const reserveDate = async (date) => {
    try {
      await fetch('/api/excursions/reserved', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ date, note: 'Заброньовано' }),
      });
      fetchReserved();
    } catch (err) {
      alert('Помилка');
    }
  };

  const unreserveDate = async (date) => {
    try {
      await fetch(`/api/excursions/reserved/${date}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      fetchReserved();
    } catch (err) {
      alert('Помилка');
    }
  };

  const addExcursion = async (e) => {
    e.preventDefault();
    try {
      await fetch('/api/excursions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        body: JSON.stringify({ ...form, slots: parseInt(form.slots) }),
      });
      setForm({ date: '', time: '', adults: '', children: '', discounts: '', responsible_name: '', responsible_phone: '', status: 'не оплачено', notes: '' });
      fetchExcursions();
    } catch (err) {
      alert('Помилка');
    }
  };

  const deleteExcursion = async (id) => {
    try {
      await fetch(`/api/excursions/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      fetchExcursions();
    } catch (err) {
      alert('Помилка');
    }
  };

  const logout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  // Calendar logic
  const getDaysInMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  const getFirstDayOfWeek = (d) => {
    const day = new Date(d.getFullYear(), d.getMonth(), 1).getDay();
    return day === 0 ? 6 : day - 1;
  };

  const daysInMonth = getDaysInMonth(currentMonth);
  const firstDay = getFirstDayOfWeek(currentMonth);
  const today = new Date();
  const cells = [];
  for (let i = 0; i < firstDay; i++) cells.push(null);
  for (let i = 1; i <= daysInMonth; i++) cells.push(i);

  const excursionsByDate = {};
  excursions.forEach(ex => {
    if (!excursionsByDate[ex.date]) excursionsByDate[ex.date] = [];
    excursionsByDate[ex.date].push(ex);
  });

  const reservedSet = new Set(reservedDates.map(r => r.date));

  const dateKey = (day) => {
    const y = currentMonth.getFullYear();
    const m = String(currentMonth.getMonth() + 1).padStart(2, '0');
    const dd = String(day).padStart(2, '0');
    return `${y}-${m}-${dd}`;
  };

  const selectedExcursions = selectedDate ? excursionsByDate[selectedDate] || [] : [];

  const prevMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  const nextMonth = () => setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <header style={{ background: '#000', color: '#fff', padding: '20px 40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ whiteSpace: 'nowrap' }}>Адмін панель G-Museum</h1>
        <button onClick={logout} style={{ padding: '8px 16px', cursor: 'pointer' }}>Вийти</button>
      </header>
      <nav style={{ background: '#fff', padding: '0 40px', borderBottom: '1px solid #ddd', display: 'flex', gap: '30px' }}>
        <button onClick={() => setTab('settings')} style={{ padding: '15px 0', background: 'none', border: 'none', borderBottom: tab === 'settings' ? '2px solid #000' : 'none', cursor: 'pointer' }}>Налаштування</button>
        <button onClick={() => setTab('excursions')} style={{ padding: '15px 0', background: 'none', border: 'none', borderBottom: tab === 'excursions' ? '2px solid #000' : 'none', cursor: 'pointer' }}>Екскурсії</button>
        <button onClick={() => { setTab('orders'); fetchOrders(); setTimeout(() => searchInputRef.current && searchInputRef.current.focus(), 50); }} style={{ padding: '15px 0', background: 'none', border: 'none', borderBottom: tab === 'orders' ? '2px solid #000' : 'none', cursor: 'pointer' }}>Онлайн замовлення</button>
      </nav>
      <main style={{ padding: '40px', maxWidth: '1100px', margin: '0 auto' }}>
        {tab === 'settings' && (
          <>
          <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', marginBottom: '30px' }}>
            <h2 style={{ marginBottom: '20px' }}>Базова ціна квитка</h2>
            <form onSubmit={savePrice} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Дорослий (грн)</label>
                <input type="number" value={basePrice} onChange={(e) => setBasePrice(e.target.value)} style={{ padding: '10px', width: '120px' }} />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Дитячий (грн)</label>
                <input type="number" value={childPrice} onChange={(e) => setChildPrice(e.target.value)} style={{ padding: '10px', width: '120px' }} />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Пільговий (грн)</label>
                <input type="number" value={discountPrice} onChange={(e) => setDiscountPrice(e.target.value)} style={{ padding: '10px', width: '120px' }} />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Пільговий безкоштовний (грн)</label>
                <input type="number" value={freeDiscountPrice} onChange={(e) => setFreeDiscountPrice(e.target.value)} style={{ padding: '10px', width: '120px' }} />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Вартість екскурсії (грн)</label>
                <input type="number" value={excursionPrice} onChange={(e) => setExcursionPrice(e.target.value)} style={{ padding: '10px', width: '120px' }} />
              </div>
              <button type="submit" style={{ padding: '10px 20px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer', width: 'fit-content' }}>Зберегти</button>
            </form>
          </div>
          <div style={{ background: '#fff', padding: '30px', borderRadius: '8px' }}>
            <h2 style={{ marginBottom: '20px' }}>Змінити логін та пароль</h2>
            <form onSubmit={changeCredentials} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Новий логін</label>
                <input type="text" value={newUsername} onChange={(e) => setNewUsername(e.target.value)} style={{ padding: '10px', width: '200px' }} />
              </div>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <label style={{ width: '200px' }}>Новий пароль</label>
                <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} style={{ padding: '10px', width: '200px' }} />
              </div>
              <button type="submit" style={{ padding: '10px 20px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer', width: 'fit-content' }}>Зберегти</button>
            </form>
          </div>
          </>
        )}
        {tab === 'excursions' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
            <div style={{ background: '#fff', padding: '30px', borderRadius: '8px' }}>
              <h2 style={{ marginBottom: '20px' }}>Додати екскурсію</h2>
              <form onSubmit={addExcursion} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Дата</label>
                  <input type="date" value={form.date} onChange={(e) => setForm({ ...form, date: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Час</label>
                  <select value={form.time} onChange={(e) => setForm({ ...form, time: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required>
                    <option value="">--</option>
                    {['09:00','10:00','11:00','14:00','15:00']
                      .filter(t => !excursions.some(ex => ex.date === form.date && ex.time === t))
                      .map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Дорослих</label>
                  <input type="number" value={form.adults} onChange={(e) => setForm({ ...form, adults: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Дитячих</label>
                  <input type="number" value={form.children} onChange={(e) => setForm({ ...form, children: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Пільгових</label>
                  <input type="number" value={form.discounts} onChange={(e) => setForm({ ...form, discounts: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Статус</label>
                  <select value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }}>
                    <option value="не оплачено">Не оплачено</option>
                    <option value="оплачено">Оплачено</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Примітки</label>
                  <textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box', minHeight: '60px' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Відповідальна особа</label>
                  <input type="text" value={form.responsible_name} onChange={(e) => setForm({ ...form, responsible_name: e.target.value })} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>Телефон</label>
                  <input type="text" value={form.responsible_phone} onChange={(e) => {
                    let v = e.target.value;
                    if (!v.startsWith('+380')) v = '+380' + v.replace(/^\+?3?8?0?/, '');
                    setForm({ ...form, responsible_phone: v });
                  }} style={{ padding: '10px', width: '100%', boxSizing: 'border-box' }} required />
                </div>
                <button type="submit" style={{ padding: '10px 20px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer' }}>Додати</button>
              </form>
            </div>
            <div style={{ background: '#fff', padding: '30px', borderRadius: '8px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <button onClick={prevMonth} style={{ padding: '5px 10px', cursor: 'pointer' }}>◀</button>
                <h2>{UA_MONTHS[currentMonth.getMonth()]} {currentMonth.getFullYear()}</h2>
                <button onClick={nextMonth} style={{ padding: '5px 10px', cursor: 'pointer' }}>▶</button>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '5px', textAlign: 'center' }}>
                {UA_DAYS.map(d => <div key={d} style={{ fontWeight: 600, padding: '8px' }}>{d}</div>)}
                {cells.map((day, idx) => {
                  if (day === null) return <div key={idx} />;
                  const key = dateKey(day);
                  const hasEx = !!excursionsByDate[key];
                  const isReserved = reservedSet.has(key);
                  const isToday = today.getDate() === day && today.getMonth() === currentMonth.getMonth() && today.getFullYear() === currentMonth.getFullYear();
                  return (
                    <div
                      key={idx}
                      onClick={() => setSelectedDate(key)}
                      style={{
                        padding: '10px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        background: isReserved ? '#ff6b6b' : (hasEx ? '#ffcc00' : (isToday ? '#eee' : 'transparent')),
                        fontWeight: isToday ? 700 : 400,
                        border: selectedDate === key ? '2px solid #000' : '1px solid #ddd',
                      }}
                    >
                      {day}
                    </div>
                  );
                })}
              </div>
              {selectedDate && (
                <div style={{ marginTop: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '4px' }}>
                  <h3 style={{ marginBottom: '10px' }}>{selectedDate}</h3>
                  {reservedSet.has(selectedDate) && (
                <div style={{ padding: '10px', background: '#ffe0e0', borderRadius: '4px', marginBottom: '10px' }}>
                  <p><strong>Заброньовано</strong></p>
                  <button onClick={() => unreserveDate(selectedDate)} style={{ marginTop: '8px', padding: '5px 10px', background: '#d33', color: '#fff', border: 'none', cursor: 'pointer' }}>Розблокувати</button>
                </div>
              )}
              {!reservedSet.has(selectedDate) && (
                <button onClick={() => reserveDate(selectedDate)} style={{ marginBottom: '10px', padding: '8px 16px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer' }}>Забронювати день</button>
              )}
              {selectedExcursions.length === 0 && !reservedSet.has(selectedDate) ? (
                    <p>Вільний день</p>
                  ) : (
                    selectedExcursions.map(ex => (
                      <div key={ex.id} style={{ padding: '10px', background: '#fff', borderRadius: '4px', marginBottom: '10px' }}>
                        <p><strong>Час:</strong> {ex.time}</p>
                        <p><strong>Дорослих:</strong> {ex.adults} <strong>Дитячих:</strong> {ex.children} <strong>Пільгових:</strong> {ex.discounts}</p>
                        <p><strong>Статус:</strong> {ex.status}</p>
                        {ex.notes && <p><strong>Примітки:</strong> {ex.notes}</p>}
                        <p><strong>Відповідальна особа:</strong> {ex.responsible_name}</p>
                        <p><strong>Телефон:</strong> {ex.responsible_phone}</p>
                        <button onClick={() => deleteExcursion(ex.id)} style={{ marginTop: '8px', padding: '5px 10px', background: '#d33', color: '#fff', border: 'none', cursor: 'pointer' }}>Видалити</button>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
        )}
        {tab === 'excursions' && (
          <div style={{ background: '#fff', padding: '30px', borderRadius: '8px', marginTop: '30px' }}>
            <h2 style={{ marginBottom: '20px' }}>Заброньовані дати</h2>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginBottom: '20px' }}>
              <input type="date" id="reserve-date-input" style={{ padding: '10px' }} />
              <button onClick={() => {
                const inp = document.getElementById('reserve-date-input');
                if (inp && inp.value) { reserveDate(inp.value); inp.value = ''; }
              }} style={{ padding: '10px 20px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer' }}>Забронювати день</button>
            </div>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {reservedDates.map(r => (
                <li key={r.id} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', borderBottom: '1px solid #eee' }}>
                  <span>{r.date}</span>
                  <button onClick={() => unreserveDate(r.date)} style={{ padding: '4px 10px', background: '#d33', color: '#fff', border: 'none', cursor: 'pointer' }}>Розблокувати</button>
                </li>
              ))}
            </ul>
          </div>
        )}
        {tab === 'orders' && (
          <div style={{ background: '#fff', padding: '30px', borderRadius: '8px' }}>
            <h2 style={{ marginBottom: '20px' }}>Онлайн замовлення</h2>
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px' }}>
              <input ref={searchInputRef} type="text" placeholder="Пошук по всій базі..." value={orderSearch} onChange={(e) => setOrderSearch(e.target.value)} style={{ padding: '10px', flex: 1 }} />
              <button onClick={() => fetchOrders(orderSearch)} style={{ padding: '10px 20px', background: '#000', color: '#fff', border: 'none', cursor: 'pointer' }}>Шукати</button>
              <button onClick={() => { setOrderSearch(''); fetchOrders(); }} style={{ padding: '10px 20px', background: '#555', color: '#fff', border: 'none', cursor: 'pointer' }}>Скинути</button>
            </div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ borderBottom: '2px solid #ddd' }}>
                    <th style={{ textAlign: 'left', padding: '8px' }}>№</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Дата</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Час</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Тип</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Вартість екскурсії</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Дор.</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Дит.</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Пільг.</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Безк.</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Сума</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>ПІБ</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Телефон</th>
                    <th style={{ textAlign: 'left', padding: '8px' }}>Створено</th>
                  </tr>
                </thead>
                <tbody>
                  {(Array.isArray(orders) ? orders : []).map(o => (
                    <tr key={o.id} style={{ borderBottom: '1px solid #eee' }}>
                      <td style={{ padding: '8px' }}>
                        {o.order_number}
                        <button
                          onClick={() => { navigator.clipboard.writeText(o.order_number); }}
                          title="Копіювати"
                          style={{ marginLeft: '6px', padding: '2px 6px', background: '#eee', border: 'none', cursor: 'pointer', borderRadius: '3px', fontSize: '11px' }}
                        >📋</button>
                      </td>
                      <td style={{ padding: '8px' }}>{o.date}</td>
                      <td style={{ padding: '8px' }}>{o.time}</td>
                      <td style={{ padding: '8px' }}>{o.visit_type}</td>
                      <td style={{ padding: '8px' }}>{o.excursion_cost}</td>
                      <td style={{ padding: '8px' }}>{o.adults}</td>
                      <td style={{ padding: '8px' }}>{o.children}</td>
                      <td style={{ padding: '8px' }}>{o.discounts}</td>
                      <td style={{ padding: '8px' }}>{o.free_discounts}</td>
                      <td style={{ padding: '8px' }}><strong>{o.total_sum}</strong></td>
                      <td style={{ padding: '8px' }}>{o.name}</td>
                      <td style={{ padding: '8px' }}>{o.phone}</td>
                      <td style={{ padding: '8px' }}>{o.created_at}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {orders.length === 0 && <p style={{ padding: '20px', textAlign: 'center' }}>Немає замовлень</p>}
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
